import { Popover, TextLink, Text } from '@oneaudi/unified-web-components';
import React, { useState } from 'react';
import { ChainDealer, DealerChainWrapper } from '../styles/CarinfoWrapper.styles';
import { useChainDealers } from '../../../hooks/useChainDealersRethink';
import { useI18n } from '@oneaudi/i18n-context';
const DealerChainPopover = ({ label, ariaLabel, vehicle }) => {
    const [open, setOpen] = useState(false);
    const { dealers } = useChainDealers(vehicle);
    const dealerchainPopoverArialabel = useI18n({
        id: 'stockcars.dealer.popover.arialabel',
        defaultMessage: 'Dealer chain details popover',
    });
    const dealerAddressFormat = useI18n({
        id: 'stockcars.dealer.popover.information',
        defaultMessage: '',
    });
    const getDealerAdress = (city, street, zipCode) => {
        return dealerAddressFormat
            .replace('{{city}}', city)
            .replace('{{street}}', street)
            .replace('{{zipCode}}', zipCode);
    };
    const popoverContent = (React.createElement("div", null,
        React.createElement(DealerChainWrapper, null, dealers === null || dealers === void 0 ? void 0 : dealers.map((dealer) => {
            const dealerAddress = getDealerAdress(dealer === null || dealer === void 0 ? void 0 : dealer.city, dealer === null || dealer === void 0 ? void 0 : dealer.street, dealer === null || dealer === void 0 ? void 0 : dealer.zipCode);
            return (React.createElement(ChainDealer, null,
                React.createElement(Text, { tag: "label", variant: {
                        order: '1',
                        style: 'normal',
                        type: 'copy',
                    } }, dealer === null || dealer === void 0 ? void 0 : dealer.name),
                React.createElement(Text, { tag: "label", variant: { type: 'copy', order: '3', style: 'normal' } }, dealerAddress)));
        }))));
    return (React.createElement(Popover, { "aria-label": dealerchainPopoverArialabel, content: popoverContent, "data-testid": "dealer-chain-popover", id: "dealer-chain-popover", onClose: () => {
            setOpen(false);
        }, triggerElement: React.createElement(TextLink, { "data-testid": "dealerChainName", icon: "forward", iconPosition: "trailing", margin: [0, 0, 0, 0], onClick: () => {
                setOpen(!open);
            }, size: "sm", "aria-label": ariaLabel, variant: "standalone" }, label), withTip: true, open: open }));
};
export default DealerChainPopover;
